import script from "./RoleGate.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleGate.vue?vue&type=script&setup=true&lang=js"

import "./RoleGate.vue?vue&type=style&index=0&id=177dfd98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-177dfd98"]])

export default __exports__